import { http } from ".";

export interface CurrentSubscriptionResponse {
  id: string;
  product: {
    id: string;
    revenue_cat_product_id: string;
    display_name: string;
    style_credits: number;
    image_credits: number;
    tier: "FREE" | "LITE" | "BASIC" | "PRO";
    renewable_type: "MONTHLY" | "YEARLY" | "NONRENEWABLE";
  };
  style_credits: number;
  image_credits: number;
  start_date: string;
  end_date?: string;
  transaction_id?: string;
  original_transaction_id?: string;
  payment_source?: "APPLE" | "STRIPE";
  status: "ACTIVE" | "CANCELLED" | "EXPIRED";
  billing_issue_date?: string | null;
  period_type: "TRIAL" | "NORMAL";
  user: number;
  management_url?: string | null;
}

export async function fetchCurrentSubscription() {
  console.log("📡 [Backend Call] Fetching current subscription...");
  
  const response = await http.get<CurrentSubscriptionResponse>(`/subscriptions/current/`);
  
  console.log("📡 [Backend Response] Full subscription response:", response);
  console.log("📡 [Backend Response] User field (numeric ID):", response.user);
  console.log("📡 [Backend Response] User field type:", typeof response.user);
  console.log("📡 [Backend Response] Transaction ID:", response.transaction_id);
  console.log("📡 [Backend Response] Original Transaction ID:", response.original_transaction_id);
  
  return response;
}
